import { BaseModel } from "./base.model";

export class SelectPromoDiscountListItem {

    //#region Fields

    discountFor: string;
    referenceTable: string;
    referenceIdColumn: string;
    referenceNameColumn?: string;
    mappingTable?: string;
    mappingColumn?: string;
    inputType?: string;
    isMultiSelect?: boolean;
    isMultiselection?: boolean;
    isActive?: string;
    id?: string;

    //#endregion

    //#region Constructor

    constructor(id: string = '', discountFor: string = '', inputType: string = '') {
        this.id = id;
        this.discountFor = discountFor;
        this.inputType = inputType;
    }

    //#endregion

    //#region Methods

    static getDefaultSelectItem(): SelectPromoDiscountListItem {

        let languageId = 1;
        const languageTextMap: { [key: number]: { text: string, value: string } } = {
            1: { text: "Select All", value: "0" },
            2: { text: "Selecteer alle", value: "0" },
        };
        const defaultLanguageText = languageTextMap[languageId] || { text: "Default text", value: "0" };
        let itemObject = new SelectPromoDiscountListItem();
        itemObject.discountFor = defaultLanguageText.text;
        itemObject.id = defaultLanguageText.value;
        return itemObject;
    }

    //#endregion

}
